/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
    // {
    //     url: "/",
    //     name: "Dashboard",
    //     slug: "dashboard",
    //     icon: "HomeIcon",
    // },
    // {
    //     header: "Daftar Site",
    //     icon: "PackageIcon",
    //     i18n: "Daftar Site",
    //     items: [],
    // },
    // {
    //     header: "Daftar Kamera",
    //     i18n: "Daftar Kamera",
    //     icon: "VideoIcon",
    //     items: [{
    //         url: "/camera/all",
    //         name: "Semua Kamera",
    //         slug: "camera",
    //         icon: "VideoIcon",
    //     }],
    // },
    // {
    //     header: "Konfigurasi",
    //     icon: "PackageIcon",
    //     i18n: "Konfigurasi",
    //     items: [{
    //             url: "/site_settings",
    //             name: "Site Settings",
    //             slug: "site-settings",
    //             icon: "GlobeIcon",
    //             i18n: "Site Settings",
    //         },
    //         {
    //             url: "/user_settings",
    //             name: "User Settings",
    //             slug: "user-settings",
    //             icon: "UserIcon",
    //             i18n: "User Settings",
    //         },
    //         {
    //             url: "/user_privilage",
    //             name: "User Privilage",
    //             slug: "user-privilage",
    //             icon: "LockIcon",
    //             i18n: "User Privilage",
    //         },
    //     ],
    // },
    {
        url: "/views",
        name: "Views",
        slug: "views",
        icon: "VideoIcon",
        i18n: "Views",
    },
    {
        url: "/bookmark",
        name: "Bookmark",
        slug: "bookmark",
        icon: "BookmarkIcon",
        i18n: "Bookmark",
    },
    {
        url: "/org_management",
        name: "Org. Management",
        slug: "org_management",
        icon: "ServerIcon",
        i18n: "Org. Management",
        role: "admin"
    },
    {
        url: "/reports",
        name: "Report Counting",
        slug: "reports",
        icon: "PieChartIcon",
        i18n: "Report Counting",
    },
    {
        url: "/report_occupancy",
        name: "Report Occupancy",
        slug: "report_occupancy",
        icon: "BarChartIcon",
        i18n: "Report Occupancy",
    },
    {
        url: "/alarm",
        name: "Alarm Notification",
        slug: "alarm",
        icon: "BellIcon",
        i18n: "Alarm",
    },
    {
        url: "/help",
        name: "Help",
        slug: "help",
        icon: "HelpCircleIcon",
        i18n: "Reports",
    },
    {
        url: "/pages/logout",
        name: "Log Out",
        slug: "logout",
        icon: "LockIcon",
        i18n: "Log Out",
    }
];